import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import MarketplaceNavbar from '../../components/MarketplaceNavbar'
import { orderPoints } from '../services/apis';
import './CheckOut.css';
import { makeAuthenticatedPOSTRequest } from '../services/serverHelper';
import { toast } from 'react-toastify';
import qrcode from '../../assets/UPI QR/image.png'

const initialFormState = {
  emailId: '',
  phoneno: '',
  
  pricing:{
    amount:0,
    transactionId: '',
    mode: 'UPI',
  }
};

const CheckOut = () => {
  const cartItems = useSelector((state) => state.cart?.cartItems || []);
  const {accessToken} = useSelector(state => state.auth);
  const itemCount = useMemo(
    () => cartItems.reduce((sum, item) => sum + (item.quantity || 1), 0),
    [cartItems]
  );
  const orderTotal = useMemo(
    () => cartItems.reduce((sum, item) => sum + ((item.pricing?.amount || 0) * (item.quantity || 1)), 0),
    [cartItems]
  );

  console.log("CartItems:", cartItems);
  const [formData, setFormData] = useState({
    emailId: '',
    phoneno: '',
    productId:cartItems.map(item => item._id),
    artistIds:cartItems.map(item => item.artist),
    userId: localStorage.getItem('artId'),
    payment:{
        amount: orderTotal,
        transactionId: '',
        mode: 'UPI',
    }
    });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  console.log("Form Data:", formData);

  const bankDetails = {
    holder: ' KUTUMB ASPIRATION PRIVATE LIMITED',
    bank: 'ICICI Bank',
    account: '033505003652',
    ifsc: 'ICIC0000335',
    branch: 'Delhi Naraina Vihar',
    upi: '8976020243.eazypay@icici',
  };

  const handleCopy = async (value) => {
    try {
      await navigator.clipboard.writeText(value);
      window.alert('Copied to clipboard');
    } catch (err) {
      console.error('Copy failed', err);
    }
  };

  const validate = () => {
    const validationErrors = {};
    if (!formData.emailId.trim()) {
      validationErrors.emailId = 'Email Address is required.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      validationErrors.emailId = 'Enter a valid emailId address.';
    }
    if (!formData.phoneno.trim()) {
      validationErrors.phoneno = 'Phone Number is required.';
    } else if (!/^\d{10,12}$/.test(formData.phoneno.replace(/\D/g, '')) ) {
      validationErrors.phoneno = 'Enter a valid phoneno number.';
    }
    if (!formData.payment.transactionId.trim()) {
      validationErrors.transactionId = 'Transaction ID / UTR Number is required.';
    }
    return validationErrors;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
    setSuccess(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      setSuccess(false);
      return;
    }

    setLoading(true);
    setErrors({});
    setSuccess(false);
    console.log(formData);

    const response = await makeAuthenticatedPOSTRequest(
        orderPoints.CREATE_ORDER_API,
        formData,
        accessToken
    )

    console.log('Transaction verification submitted', response.data);

    if(response.statusCode === 200){
        setLoading(false);
        setSuccess(true);
        toast.success('Order Placed.')
    }else{
        setSuccess(false);
        setLoading(false);
        toast.error("Order not placed successfully")
    }

  };

  const displayTotal = orderTotal || 1299;
  const displayItems = itemCount || 1;

  return (
    <>
        <MarketplaceNavbar />
        <div className="checkout-page">
        <div className="checkout-content">
            <header className="checkout-header">
            <div>
                <p className="checkout-kicker">Secure Payment</p>
                <h1 className="checkout-title">Checkout and submit your transaction details</h1>
                <p className="checkout-subtitle">
                    Complete your payment and share transaction verification for fast confirmation.
                </p>
            </div>
            </header>

            <section className="checkout-grid">
            <div className="checkout-column-details">
                <div className="checkout-card payment-card">
                <div className="card-headline">
                    <div>
                        <p className="section-label">UPI Payment</p>
                        <h2>Scan & Pay</h2>
                    </div>
                </div>

                <div className="upi-card">
                    {/* <div className='qr-code' style={{alignSelf:"center"}}>
                    </div> */}
                    <div className="qr-placeholder">
                        <img src={qrcode}  />
                    {/* <span>QR Code</span> */}
                    </div>
                    <div className="upi-details">
                    <div>
                        <p className="detail-label">UPI ID</p>
                        <p className="detail-value">{bankDetails.upi}</p>
                    </div>
                    <button
                        type="button"
                        className="copy-button"
                        onClick={() => handleCopy(bankDetails.upi)}
                    >
                        Copy UPI ID
                    </button>
                    </div>
                </div>

                <p className="instruction-text">
                    Scan the QR code using your UPI app or copy the UPI ID to complete payment instantly.
                </p>
                </div>

                <div className="checkout-card bank-details-card">
                <div className="card-headline">
                    <div>
                    <p className="section-label">NEFT / Bank Transfer</p>
                    <h2>Bank details</h2>
                    </div>
                </div>

                <div className="bank-details">
                    <div className="bank-row">
                    <span>Account Holder</span>
                    <strong>{bankDetails.holder}</strong>
                    </div>
                    <div className="bank-row">
                    <span>Bank Name</span>
                    <strong>{bankDetails.bank}</strong>
                    </div>
                    <div className="bank-row with-action">
                    <div>
                        <span>Account Number</span>
                        <strong>{bankDetails.account}</strong>
                    </div>
                    <button type="button" className="copy-button" onClick={() => handleCopy(bankDetails.account)}>
                        Copy
                    </button>
                    </div>
                    <div className="bank-row with-action">
                    <div>
                        <span>IFSC Code</span>
                        <strong>{bankDetails.ifsc}</strong>
                    </div>
                    <button type="button" className="copy-button" onClick={() => handleCopy(bankDetails.ifsc)}>
                        Copy
                    </button>
                    </div>
                    <div className="bank-row">
                    <span>Branch</span>
                    <strong>{bankDetails.branch}</strong>
                    </div>
                </div>
                </div>

                <div className="summary-card sticky-card">
                <div className="summary-title">Order Summary</div>
                <div className="summary-row">
                    <span>Items</span>
                    <span>{displayItems} product{displayItems > 1 ? 's' : ''}</span>
                </div>
                <div className="summary-row">
                    <span>Payment mode</span>
                    <span>{formData.mode}</span>
                </div>
                <div className="divider" />
                <div className="summary-total-row">
                    <span>Grand total</span>
                    <strong>₹{displayTotal}</strong>
                </div>
                <p className="summary-note">
                    Once you submit your transaction details, our admin will verify payment and confirm your order.
                </p>
                </div>
            </div>

            <div className="checkout-column-form">
                <form className="verification-card" onSubmit={handleSubmit} noValidate>
                <div className="card-headline">
                    <div>
                        <p className="section-label">Transaction Verification</p>
                        <h2>Submit your payment details</h2>
                    </div>
                </div>

                <div className="form-grid">
                    {/* <label className="form-group">
                    <span>Full Name<span className="required">*</span></span>
                    <input
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className={errors.name ? 'input-field invalid' : 'input-field'}
                        placeholder="Enter full name"
                    />
                    </label>
                    {errors.name && <span className="field-error">{errors.name}</span>} */}

                    <label className="form-group">
                    <span>Email Address to send the link<span className="required">*</span></span>
                    <input
                        name="emailId"
                        type="emailId"
                        value={formData.emailId}
                        onChange={handleChange}
                        className={errors.emailId ? 'input-field invalid' : 'input-field'}
                        placeholder="example@mail.com"
                    />
                    {errors.emailId && <span className="field-error">{errors.emailId}</span>}
                    </label>

                    <label className="form-group">
                    <span>Phone Number<span className="required">*</span></span>
                    <input
                        name="phoneno"
                        type="tel"
                        value={formData.phoneno}
                        onChange={handleChange}
                        className={errors.phoneno ? 'input-field invalid' : 'input-field'}
                        placeholder="9876543210"
                    />
                    {errors.phoneno && <span className="field-error">{errors.phoneno}</span>}
                    </label>

                    <label className="form-group">
                    <span>Transaction ID / UTR<span className="required">*</span></span>
                    <input
                        name="transactionId"
                        value={formData?.payment?.transactionId}
                        onChange={e => setFormData((prev) => ({ ...prev, payment: { ...prev.payment, transactionId: e.target.value } }))}
                        className={errors.transactionId ? 'input-field invalid' : 'input-field'}
                        placeholder="Enter transaction reference"
                    />
                    {errors.transactionId && <span className="field-error">{errors.transactionId}</span>}
                    </label>

                    <label className="form-group">
                    <span>Payment Method<span className="required">*</span></span>
                    <select
                        name="mode"
                        value={formData?.payment?.mode}
                        onChange={e => setFormData((prev) => ({ ...prev, payment: { ...prev.payment, mode: e.target.value } }))}
                        className="input-field select-field"
                    >
                        <option value="UPI">UPI</option>
                        <option value="NEFT">NEFT</option>
                    </select>
                    </label>

                    {/* <label className="form-group">
                    <span>Amount Paid<span className="required">*</span></span>
                    <input
                        name="amount"
                        type="number"
                        value={formData.amount}
                        onChange={handleChange}
                        className={errors.amount ? 'input-field invalid' : 'input-field'}
                        placeholder="₹ 0.00"
                    />
                    {errors.amount && <span className="field-error">{errors.amount}</span>}
                    </label> */}

                    {/* <label className="form-group form-group-full">
                    <span>Additional Notes</span>
                    <textarea
                        name="notes"
                        value={formData.notes}
                        onChange={handleChange}
                        className="input-field textarea-field"
                        placeholder="Add any note for admin verification"
                        rows="4"
                    />
                    </label> */}
                </div>

                {success && (
                    <div className="success-banner">
                    Your verification request has been submitted successfully.
                    </div>
                )}

                <button type="submit" className="primary-button" disabled={loading}>
                    {loading ? 'Submitting...' : 'Submit Transaction'}
                </button>
                </form>
            </div>
            </section>
        </div>
        </div>
    </>
  );
};

export default CheckOut;